<template>
  <div v-if="showFreeCenterBar">
    <div
      v-if="isDesktop"
      class="announce-bar responsive-visible desktop"
      @click="handleClickBar"
    >
      <span class="announce-bar__content">
        무료 플랜 이용 중입니다. 정식 플랜으로 미리 전환하세요!
      </span>
    </div>
    <div
      v-else
      class="announce-bar responsive-visible mobile"
      @click="handleClickBar"
    >
      <span class="announce-bar__content">
        무료 플랜 이용 중입니다.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FreeCenterBar',
  props: {
    isDesktop: {
      type: Boolean,
      default: true
    }
  },
  created() {
    this.showFreeCenterBar = !this.$localStore.getValue('notShowFreeCenterBar');
  },
  data() {
    return {
      showFreeCenterBar: false
    };
  },
  methods: {
    handleClickBar() {
      window.open('https://bit.ly/3NkPuAb', '_blank');
    }
  }
};
</script>

<style scoped>
</style>
